<div class="add-comment-container">
  <div class="add-comment__header">
    <div class="add-comment__header-text">
      <img class="add-comment__icon" src="/assets/icons/add-icon-secondary-font-color.png">
      <span class="add-comment__label">ADD A COMMENT</span>
    </div>
    <div class="add-comment__close">
      <img class="themified-white-icon add-comment__close-icon" src="/assets/icons/cross-icon.png" (click)="closeAddCommentModal()" />
    </div>
  </div>
  <div class="add-comment__content">
    <div class="add-comment__comment">
      <mat-form-field appearance="fill" class="custom-mat-form-field add-comment__form-field">
        <mat-label>COMMENT</mat-label>
        <textarea matInput rows="10" [(ngModel)]="commentContent" #commentValue="ngModel" required></textarea>
        <mat-error *ngIf="commentValue.invalid">
          <span> {{ 'screening_result.message.invalid_comment_error' | translate }} </span>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="add-comment__action">
      <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded" (click)="saveComment()"
        [disabled]="commentValue.invalid">
        Confirm
      </button>
    </div>
  </div>
</div>